export const CUSTOM_FILTER_TITLE: Record<string, string> = {
  assetSubtreeIds: 'Asset',
  createdTime: 'Created Time',
  lastUpdatedTime: 'Updated Time',
  externalIdPrefix: 'External ID',
  dataSetIds: 'Data sets',
  mimeType: 'File type',
  internalId: 'Internal ID',
} as const;
